import React from 'react';
import Grid from '@material-ui/core/Grid';

const GridBlock = (props) =>  (
  <Grid container>
    <Grid item xs sm={2} md lg={1} />
    <Grid item xs={12} sm={8} md={12} lg={10} >
      {props.children}
    </Grid>
    <Grid item xs sm={2} md={1} lg={1} />
  </Grid>
);
export default GridBlock;



// WEBPACK FOOTER //
// ./src/components/grid-block/grid-block.jsx